<template>
  <div>
    <v-col cols="3">
      <v-btn
        block
        height="42px"
        color="#1db954"
        class="download-btn"
        @click="openModal('create')"
        style="color: black"
      >
        <v-icon>mdi mdi-plus-thick</v-icon>
        Neu
      </v-btn>
    </v-col>
    <v-data-table
      :key="mammalUpdateKey"
      :headers="headers"
      :search="performSearch"
      :items="mammals"
      :loading="isLoading"
      :footer-props="{
        'items-per-page-text': 'Zeilen pro Seite',
      }"
    >
      <template v-slot:item.actions="{ item }">
        <div class="button-container">
          <v-icon
            small
            class="edit green--text icon-style"
            @click="openModal('update', item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="delete green--text icon-style"
            @click="openDeleteModal('delete', item)"
          >
            mdi-delete
          </v-icon>
        </div>
      </template>
    </v-data-table>
    <create-mammal
      :mammal="{ abbreviation: '', name: '' }"
      :visible="dialogType === 'create'"
      :id="null"
      @close="closeModal"
      @addItem="addItem"
      v-on:updated-table="updatedList"
    />
    <update-mammal
      :key="mammalUpdateKey"
      :mammal="selectedMammal"
      :visible="dialogType === 'update'"
      :id="selectedMammal.id"
      @close="closeModal"
      @updateItem="updateItem"
      v-on:updated-table="updatedList"
    />
    <delete-mammal
      :visible="dialogType === 'delete'"
      :mammal="selectedMammal"
      :item-list="itemList"
      v-on:updated-table="updatedList"
      @close="closeDeleteModal"
    ></delete-mammal>
  </div>
</template>

<script>
import CreateMammal from "./CreateMammal";
import UpdateMammal from "./UpdateMammal";
import DeleteMammal from "./DeleteMammal";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    CreateMammal,
    UpdateMammal,
    DeleteMammal,
  },
  data() {
    return {
      headers: [
        { text: "Abkürzung", value: "abbreviation" },
        { text: "Beschreibung", value: "name" },

        { text: "", value: "actions", sortable: false },
      ],
      itemList: [],
      mammalUpdateKey: null,
      mammalList: [],
      isLoading: false,
      dialogType: "",
      selectedMammal: {},
      localSearch: null,
      showDeleteModal: false,
    };
  },
  computed: {
    ...mapGetters(["getSearchquery", "mammals"]),

    performSearch() {
      return this.getSearchquery;
    },
  },
  mounted() {
    this.localSearch = this.getSearchquery;
    this.test();
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions(["fetchMammals", "createMammal", "updateMammal"]),
    editMammal(mammal) {
      this.selectedMammal = { ...mammal };
      this.dialogType = "update";
    },
    updatedList(boolean) {
      if (boolean) {
        this.fetchData();
      }
    },
    openModal(type, mammal) {
      this.dialogType = type;
      if (type === "update") {
        this.selectedMammal = { ...mammal };
      }
    },
    openDeleteModal(type, mammal) {
      this.dialogType = type;
      if (type === "delete") {
        this.selectedMammal = { ...mammal };
      }
    },
    closeModal() {
      this.dialogType = "";
      this.selectedMammal = {};
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
      this.dialogType = "";
      this.selectedMammal = {};
    },
    async addItem(newItem) {
      this.isLoading = true;
      await this.createMammal(newItem);
      this.closeModal();
    },
    async updateItem(item) {
      this.isLoading = true;
      await this.updateMammal(item);
      this.mammalUpdateKey += 1;
      this.closeModal();
    },
    fetchData() {
      this.isLoading = true;
      this.fetchMammals()
        .then(() => {
          this.mammals = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
  },
  handleSearch(query) {
    this.getSearchquery = query;
  },
};
</script>
<style lang="scss" scoped>
.icon-style {
  border: 1px solid #494949;
  padding: 3px;
  border-radius: 5px;
  width: 42px;
  height: 42px;
  margin-left: -60px !important;
}

.button-container {
  display: flex;
  align-items: center;
}
.button-container .delete {
  position: absolute;
  right: 15px;
}
.button-container .edit {
  position: absolute;
  right: 67px;
}
.add-button {
  outline: none !important;
  margin-bottom: 10px;
  width: 220px;
}
</style>
